<body>
<section class="container-fluid rounded shadow position-relative" id="imageBox">
    <img 
    class="bg-img" 
    ngSrc="/assets/images/organisations/gov/background2.jpg"
    width="1920" height="1080"
    fetchpriority="high"
    priority
    alt="Aerial view of Hotedršica">
    <h1 class="club-name">KRAJEVNA SKUPNOST HOTEDRŠICA</h1>
    
    <div class="d-flex flex-column flex-md-row justify-content-center align-items-center mt-4">  
      <button class="button-74 mb-3 mb-md-0 me-md-5 skrij" (click)="scrollTo('book')">Najemi dvorano</button>  
      <div class="mx-md-3 my-3 my-md-0" style="z-index: 1;">
          <!--<img src="/assets/images/organisations/gov/logo.png" alt="Club Logo" class="img-fluid" style="max-width: 120px;">-->
          <img 
          class="img-fluid" 
          ngSrc="/assets/images/organisations/gov/logo.png"
          width="120" height="120"
          fetchpriority="high"
          priority
          alt="Logo of mulicipality of Logatec">
      </div>
      <button class="button-74 mb-3 mb-md-0 ms-md-5 skrij" (click)="scrollTo('timetable')">Urnik dvorane</button> 
    </div>
    
</section>

<section id="navbar">
    <div id="orgBar" class="container-fluid">
      <button id="burger" (click)="toggleMenu()">☰</button>
      <div id="menu" [ngClass]="{ 'show': menuOpen }">
        <button class="org-button" (click)="scrollTo('news')">Novice</button>
        <button class="org-button" (click)="scrollTo('events')">Dogodki</button>
        <button class="org-button" (click)="scrollTo('old-hall')">Stara šola</button>
        <button class="org-button" (click)="scrollTo('book')">Najem dvorane</button>
        <button class="org-button" (click)="scrollTo('gallery')">Galerija</button>
        <button class="org-button" (click)="scrollTo('club-details')">Vizitka</button>
        <button class="org-button" (click)="scrollTo('library-section')">Knjižnica</button>
      </div>
    </div>
  </section>


<section *ngIf="organisation" id="news" class="p-5">
    <h1 class="club-name animated-title">NOVICE</h1>
    <!-- Content for events organized by the sports club -->
    <app-news-list 
    [organisation]="organisation" 
    [isSuperAdmin]="isSuperAdmin" 
    [isOrgAdmin]="isOrgAdmin" 
    [news]="news"
    [totalNewsCount]="totalItems"
    (loadMoreClicked)="loadMoreNews()"
    (newsChanged)="handleNewsChanged()"
    ></app-news-list>
</section>
    
<section *ngIf="organisationId" id="events" class="p-5">
    <h1 class="font-weight-bold club-name animated-title">DOGODKI</h1>
    <div class="container mt-5">
        <app-event-list 
        [allEvents]="allEvents" 
        [onOrganisationPage]="true" 
        [isOrgAdmin]="isOrgAdmin" 
        [isSuperAdmin]="isSuperAdmin" 
        [organisationID]="organisationId"
        (eventChanged)="handleEventsChanged()"
        ></app-event-list>
    </div>
</section>

<div class="curvy-container">
    </div>

<section id="old-hall" class="p-5">
    <h1 class="font-weight-bold club-name animated-title">STARA ŠOLA</h1>
    <p id="stara-sola-text" class="animated-text container">Stara šola stoji v vaškem jedru. Obnovljena stavba, ki jo upravlja Krajevna skupnost
        Hotedršica, nudi prostore društvom in krajevni knjižnici. V pritličju
        najdemo pisarno Krajevne skupnosti Hotedršica in prostor Krajevne knjižnice Hotedršica. V
        prvem nadstropju imata pisarni Športno društvo Hotedršica in Kulturno turistično društvo
        Hotedršica. Tam je tudi večnamenska dvorana.</p>
    
    <div class="row mt-4">
        <div class="col-md-3" *ngFor="let image of oldHallImages">
            <img [src]="image.src" class="img-fluid rounded shadow animated-image left-image" alt="Slika Stare Šole">
        </div>
    </div>
    <h1 class="font-weight-bold club-name animated-title" style="font-size: 30px;">DVORANA</h1>
    <p id="stara-sola-text" class="animated-text container">Manjša večnamenska dvorana je na voljo vsem društvom, ki gostujejo v Stari šoli. Prav tako
        jo lahko najamejo tudi drugi interesenti. V dvorani so na voljo <strong>stoli</strong>, <strong>projektor s platnom</strong> in
        <strong>ozvočenje</strong> ter popolna zatemnitev oken. Ena od sten je prekrita z <strong>ogledali</strong>. Večnamensko
        dvorano brezplačno uporabljajo najemniki prostorov v Stari šoli.</p>
        <ul id="stara-sola-text" class="animated-text container">
            <li>Najem dvorane stane 5 EUR na uro za organizacijo nepridobitnih dejavnosti.</li>
            <li>Najem za pridobitno dejavnost pa 15 EUR na uro.</li>
            <li>Najem dvorane urejate z obrazcem dostopnim na gumbu NAJEM DVORANE.</li>
            <li>Dogajanje v dvorani je objavljeno v koledarju.</li>
        </ul> 
    <div class="row mt-4">
      <div class="col-md-3" *ngFor="let image of dvoranaImages">
          <img [src]="image.src" class="img-fluid rounded shadow animated-image right-image" alt="Slika Stare Šole">
      </div>
    </div>   
    <h2 id="timetable" class="mt-5 font-weight-bold club-name animated-title" style="font-size: 30px;">URNIK DVORANE</h2>
    
    <div class="animated-text text-center">
      <div class="calendar-container">
        <!--<iframe 
          src="https://calendar.google.com/calendar/embed?src=d5cdbde10b8940ebecf7aab742dd14ea0a4605ba94038c0f8749a01471821a8f%40group.calendar.google.com&ctz=Europe%2FVienna" 
          style="border:solid 1px #777" 
          class="responsive-calendar"
          frameborder="0" 
          scrolling="no">
        </iframe>-->
        <iframe src="https://embed.styledcalendar.com/#R1qfxWuvgtiXVTPVh2ii" title="Styled Calendar" class="styled-calendar-container" style="width: 100%; border: none;" data-cy="calendar-embed-iframe"></iframe>
      <script async type="module" src="https://embed.styledcalendar.com/assets/parent-window.js"></script>
      </div>

    
      <button id="book" *ngIf="!showReservationForm" class="btn button-74 mt-3" (click)="openHallReservationForm()">NAJEMI DVORANO</button>
    </div>
    
    <div id="reservation" *ngIf="showReservationForm" class="mt-4 p-4 border rounded shadow bg-light">
        <h3>Rezervacija dvorane</h3>
        <form (submit)="submitReservation()">
            <div class="mb-3">
                <label for="name">Ime</label>
                <input type="text" id="name" class="form-control" [(ngModel)]="reservation.name" name="name" required>
            </div>
            <div class="mb-3">
                <label for="email">Mail</label>
                <input type="email" id="email" class="form-control" [(ngModel)]="reservation.email" name="email" required>
            </div>
            <div class="mb-3">
                <label for="phone">Telefon</label>
                <input type="text" id="phone" class="form-control" [(ngModel)]="reservation.phone" name="phone" required>
            </div>
            <div class="mb-3">
                <label for="date">Datum najema</label>
                <input type="date" id="date" class="form-control" [(ngModel)]="reservation.date" name="date" required>
            </div>
            <div class="mb-3">
                <label for="time">Ura najema</label>
                <input type="time" id="time" class="form-control" [(ngModel)]="reservation.time" name="time" required>
            </div>
            <div class="mb-3">
                <label for="duration">Trajanje</label>
                <input type="text" id="duration" class="form-control" [(ngModel)]="reservation.duration" name="duration" required>
            </div>
            <div class="mb-3">
                <label for="description">Opis najema</label>
                <textarea id="description" class="form-control" [(ngModel)]="reservation.description" name="description" required placeholder="Vnesite opis najema, ali se dejavnost ponavlja in ostale podrobnosti."></textarea>
            </div>
            <div class="mb-3">
                <label for="participants">Ali je dejavnost pridobitna?</label>
                <select id="participants" class="form-control" [(ngModel)]="reservation.isProfitable" name="participants" required>
                    <option value="DA">DA</option>
                    <option value="NE">NE</option>
                </select>
            </div>
            <button type="submit" class="btn button-74">
                <span *ngIf="!isLoading">Pošlji</span>
                <span *ngIf="isLoading">
                    <div class="spinner-border spinner-border-sm text-light" role="status"></div>
                    Pošiljanje...
                </span>
            </button>
        </form>
        <button class="btn button-74 mt-3" (click)="showReservationForm = !showReservationForm">Zapri</button>
    </div>
    
</section>

<div class="curvy-container-inv"></div>

<!--Galerija-->
<section id="gallery-section">
    <h1 class="font-weight-bold club-name animated-title">GALERIJA</h1>
    <div class="container p-5 animated-title">
        <gallery class="w-100" id="gallery" [objectFit]="'contain'" [loop]="true" [items]="govImages" (thumbClick)="onThumbClick($event)"></gallery>
        <button *ngIf="isOrgAdmin || isSuperAdmin" class="btn button-74 mt-3" (click)="openAddSportsImagesModal()">
        <fa-icon class="fa-lg me-2" [icon]="faPlus"></fa-icon>Dodaj slike</button>
        <button *ngIf="imageSelected && (isOrgAdmin || isSuperAdmin)" (click)="deleteSelectedImage()" class="btn button-74 mt-3">
        <fa-icon class="fa-lg me-2" [icon]="faTrash"></fa-icon>Izbriši izbrano sliko
        </button>
    </div>
</section>

<div class="curvy-container"></div>

<section id="club-details" class="club-details p-2">
    <h1 class="font-weight-bold club-name animated-title text-center mt-5" style="color: #972f32;">VIZITKA</h1>
  
    <div class="container mt-5">
      <div class="row g-4 animated-text">
        <div class="col-md-6 d-flex flex-column">
          <div class="card shadow-lg border-0 flex-grow-1">
            <div class="card-body">
              <h3 class="card-title mb-0" style="color: #972f32;">Kontaktni Podatki</h3>
              <hr>
              <p class="fw-bold mb-1">{{ organisation?.name }}</p>
              <p class="mb-2" *ngIf="organisation?.address">
                <fa-icon class="me-2" [icon]="faHouse" style="color: #972f32;"></fa-icon>
                {{ organisation?.address }}, {{ organisation?.postalCode }}
              </p>
              <p class="mb-2" *ngIf="organisation?.email">
                <fa-icon class="me-2" [icon]="faEnvelope" style="color: #972f32;"></fa-icon>
                {{ organisation?.email }}
              </p>
              <p class="mb-2" *ngIf="organisation?.phone">
                <fa-icon class="me-2" [icon]="faPhone" style="color: #972f32;"></fa-icon>
                {{ organisation?.phone }}
              </p>
              <p class="mb-2" *ngIf="organisation?.taxNumber">
                <strong>Davčna številka:</strong> {{ organisation?.taxNumber }}
              </p>
            </div>
          </div>
  
          <div class="card shadow-lg border-0 flex-grow-1 mt-3">
            <div class="card-body">
              <h3 class="card-title mb-3" style="color: #972f32;">Člani sveta</h3>
              <hr>
              <div *ngIf="organisation?.leaders">
                <div *ngFor="let leader of organisation!.leaders">
                  <ng-container *ngIf="leader.role === 'Predsednik'">
                    <p><strong>{{ leader.role }}:</strong> {{ leader.name }}</p>
                    <button *ngIf="isOrgAdmin || isSuperAdmin" class="btn btn-danger" (click)="deleteLeader(leader.leaderID)">
                      <fa-icon [icon]="faTrash"></fa-icon>
                    </button>
                  </ng-container>
                </div>
                <div *ngFor="let leader of organisation!.leaders">
                  <ng-container *ngIf="leader.role === 'Podpredsednik'">
                    <p><strong>{{ leader.role }}:</strong> {{ leader.name }}</p>
                    <button *ngIf="isOrgAdmin || isSuperAdmin" class="btn btn-danger" (click)="deleteLeader(leader.leaderID)">
                      <fa-icon [icon]="faTrash"></fa-icon>
                    </button>
                  </ng-container>
                </div>
                <div *ngFor="let leader of organisation!.leaders">
                  <ng-container *ngIf="leader.role === 'Tajnica'">
                    <p><strong>{{ leader.role }}:</strong> {{ leader.name }}</p>
                    <button *ngIf="isOrgAdmin || isSuperAdmin" class="btn btn-danger" (click)="deleteLeader(leader.leaderID)">
                      <fa-icon [icon]="faTrash"></fa-icon>
                    </button>
                  </ng-container>
                </div>
                <div *ngFor="let leader of organisation!.leaders">
                  <ng-container *ngIf="leader.role === 'Član'">
                    <p><strong>{{ leader.role }}:</strong> {{ leader.name }}</p>
                    <button *ngIf="isOrgAdmin || isSuperAdmin" class="btn btn-danger" (click)="deleteLeader(leader.leaderID)">
                      <fa-icon [icon]="faTrash"></fa-icon>
                    </button>
                  </ng-container>
                </div>
              </div>
  
              <!-- Toggle Button for Add Leader Form -->
              <div *ngIf="isOrgAdmin || isSuperAdmin" class="text-center mt-4">
                <button class="btn btn-primary" (click)="toggleAddLeaderForm()">
                  {{ showAddLeaderForm ? 'Skrij obrazec' : 'Dodaj novega člana' }}
                </button>
              </div>
  
              <!-- Add Leader Section (Toggles on Button Click) -->
              <div *ngIf="showAddLeaderForm" id="add-leader" class="p-5">
                <h2 class="text-center font-weight-bold">Dodaj novega člana</h2>
                <div class="container mt-5">
                  <div class="row justify-content-center">
                    <div class="col-md-6">
                      <form (ngSubmit)="onSubmitAddLeader()">
                        <div class="mb-3">
                          <label for="leaderName" class="form-label">Ime in priimek</label>
                          <input type="text" class="form-control" id="leaderName" [(ngModel)]="newLeader.name" name="name" required>
                        </div>
  
                        <div class="mb-3">
                          <label for="leaderRole" class="form-label">Vloga</label>
                          <select class="form-control" id="leaderRole" [(ngModel)]="newLeader.role" name="role" required>
                            <option value="Predsednik">Predsednik</option>
                            <option value="Podpredsednik">Podpredsednik</option>
                            <option value="Tajnica">Tajnica</option>
                            <option value="Član">Član</option>
                          </select>
                        </div>
  
                        <div class="mb-3">
                          <label for="leaderEmail" class="form-label">Email</label>
                          <input type="email" class="form-control" id="leaderEmail" [(ngModel)]="newLeader.email" name="email" required>
                        </div>
  
                        <div class="mb-3">
                          <label for="leaderPhone" class="form-label">Telefon</label>
                          <input type="tel" class="form-control" id="leaderPhone" [(ngModel)]="newLeader.phone" name="phone" required>
                        </div>
  
                        <button type="submit" class="btn btn-success">Dodaj</button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
           
        </div>
  
        <div class="col-md-6">
          <div class="card shadow-lg border-0 h-100">
            <div class="card-body">
              <h3 class="card-title mb-0" style="color: #972f32;">Uradne Ure</h3>
              <hr>
              <p>
                <strong>Ivan Špacapan</strong> – sreda od 18h do 19h 
                <br> (po predhodni telefonski najavi vsaj dan prej)
              </p>
              <p>
                <fa-icon class="me-2" [icon]="faPhone" style="color: #972f32;"></fa-icon>
                {{ organisation?.phone }}
              </p>
              <p>
                <fa-icon class="me-2" [icon]="faEnvelope" style="color: #972f32;"></fa-icon>
                {{ organisation?.email }}
              </p>
              <div class="mt-3 text-center flex-grow-1 d-flex align-items-center justify-content-center my-5">
                <img src="/assets/images/organisations/gov/background1.jpg" alt="KS Hotedršica" class="img-fluid rounded shadow-lg" style="max-width: 100%;">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="organisationId" id="report-section" class="card shadow-lg border-0 h-100 mt-3 animated-text">
        <app-report-list [orgID]="organisationId" [isAdmin]="isOrgAdmin || isSuperAdmin"></app-report-list>
      </div>
    </div>
  </section>

  <div class="curvy-container-inv"></div>
  <section id="library-section" class="club-details p-2 pb-5">
    <h1 class="font-weight-bold club-name animated-title text-center mt-5" style="color: #972f32;">KNJIŽNICA</h1>

    <div class="container mt-5">
        <div class="row g-4 animated-text">
            <!-- Contact Info & Timetable -->
            <div class="col-md-6 d-flex flex-column">
                <div class="card shadow-lg border-0 flex-grow-1">
                    <div class="card-body">
                        <h3 class="card-title mb-0" style="color: #972f32;">Kontaktni Podatki</h3>
                        <hr>
                        <p class="fw-bold mb-1">Krajevna knjižnica Hotedršica</p>
                        <p class="mb-2">
                            <fa-icon class="me-2" [icon]="faHouse" style="color: #972f32;"></fa-icon>
                            Hotedršica 64, 1372 Hotedršica
                        </p>
                        <p class="mb-2">
                            <fa-icon class="me-2" [icon]="faPhone" style="color: #972f32;"></fa-icon>
                            01/7559 506
                        </p>
                    </div>
                </div>

                <div class="card shadow-lg border-0 flex-grow-1 mt-3">
                    <div class="card-body">
                        <h3 class="card-title mb-3" style="color: #972f32;">Urnik</h3>
                        <hr>
                        <p><strong>SR:</strong> 14.00 - 19.00</p>
                        <p><strong>PE:</strong> 14.00 - 19.00</p>
                        <h4 class="mt-3" style="color: #972f32;">Poletni urnik (1.7. - 31.8.)</h4>
                        <hr>
                        <p><strong>SR:</strong> 14.00 - 19.00</p>
                    </div>
                </div>
            </div>

            <!-- Library Image -->
            <div class="col-md-6">
                <div class="card shadow-lg border-0 h-100">
                    <div class="card-body text-center">
                        <img src="/assets/images/organisations/gov/knjiznica.jpg" alt="Krajevna knjižnica Hotedršica" class="img-fluid rounded shadow-lg" style="max-width: 100%;">
                    </div>
                </div>
            </div>
        </div>

        <!-- History Section -->
        <div class="card shadow-lg border-0 h-100 mt-3 p-4 animated-title">
          <h3 class="card-title mb-3 text-center" style="color: #972f32;">ZGODOVINA KNJIŽNICE HOTEDRŠICA</h3>
          <hr>
          <p style="font-weight: 600;">{{ showFullHistory ? fullHistory : shortHistory }}...</p>
          <button class="btn btn-link p-0" (click)="toggleHistory()">
            {{ showFullHistory ? 'Skrij' : 'Preberi več' }}
          </button>
        </div>

        <!-- Events & Services -->
        <div class="card shadow-lg border-0 h-100 mt-3 p-4 animated-text">
            <h3 class="card-title mb-3 text-center" style="color: #972f32;">DOGODKI V KNJIŽNICI HOTEDRŠICA</h3>
            <hr>
            <p>
                Tekom šolskega leta v knjižnici potekajo pravljične urice za otroke, vsako redo ob 17:00.
                <br>
                Otroci naj s seboj prinesejo copate
                <br>
                Obisk pravljične urice je brezplačen.
                <br>
                Začetek: oktober 2024, konec: april 2025.
                <br>
                (Več informacij na <a href="http://www.log.sik.si/" target="_blank">http://www.log.sik.si/</a>)
            </p>
            <p>
                Organiziramo tudi predavanja za odrasle. Spremljajte nas na spletni strani <a href="http://www.log.sik.si/" target="_blank">http://www.log.sik.si/</a>.
            </p>
        </div>

        <div class="card shadow-lg border-0 h-100 mt-3 p-4 animated-text">
            <h3 class="card-title mb-3 text-center" style="color: #972f32;">STORITVE</h3>
            <hr>
            <p>
                V Knjižnici Hotedršica je na voljo brezplačen dostop do interneta na dveh računalnikih.
                Prav tako omogočamo tiskanje (za plačilo).
                <br>
                Gradivo si lahko izposojajo vsi člani Knjižnice Logatec.
            </p>
        </div>
    </div>
</section>

  
</body>
